import { uiState } from "../../state";

export function adjustIFrameSize(iframeMsgData: {
    height: number,
    width: number,
    iframeId: string,
    withSvg: boolean,
}) {
    const maxIFrameHeight = 1400;
    var { height, width, iframeId, withSvg } = iframeMsgData;

    console.info('adjustIFrameSize', height, width);

    const iframeEls = document.querySelectorAll('#' + iframeId) as NodeListOf<HTMLIFrameElement>;

    iframeEls.forEach((iframeEl) => {
        const responseWrapper = iframeEl.closest('.alan-btn__chat-response, .chat-bubble_message') || iframeEl.closest('body');


        if (Math.abs(iframeEl.clientHeight - height) !== 20) {
            iframeEl.style.height = (+height > maxIFrameHeight ? maxIFrameHeight : height) + 'px';
        }

        if (!responseWrapper) {
            iframeEl.style.width = '100%';
            return;
        }

        if (withSvg) {
            if (!responseWrapper.classList.contains('with-svg')) {
                responseWrapper.classList.add('with-svg');
                iframeEl.style.width = '100%';
                setTimeout(() => {
                    broadcastReloadIframeToIframes();
                }, 50);
            }
        } else {
            if (height < 650) {
                changeWidthIfNeeded(iframeEl, width);
            } else {
                if (responseWrapper.clientWidth <= width) {
                    changeWidthIfNeeded(iframeEl, width);
                } else {
                    iframeEl.style.width = '100%';
                }
            }
        }
    });

    function changeWidthIfNeeded(iframeEl, newWidth) {
        if (Math.abs(iframeEl.clientWidth - newWidth) !== 20) {
            iframeEl.style.width = newWidth + 'px';
        }
    }
}

export function broadcastThemeToIframes() {
    let theme;

    try {
        theme = uiState?.currentTheme;
    } catch (error) {
        theme = window['alanCurrentTheme'];
    }

    const iframes = window.frames;
    const message = {
        type: 'alanThemeEvent',
        theme
    };

    if (!theme) return;

    for (let i = 0; i < iframes.length; i++) {
        try {
            iframes[i].postMessage(message, '*');
        } catch (error) {
            console.error(`Failed to send message to iframe ${i}`, error);
        }
    }
}

export function broadcastReloadIframeToIframes() {
    const iframes = window.frames;
    const message = {
        type: 'alanReloadIFrameEvent',
    };

    for (let i = 0; i < iframes.length; i++) {
        try {
            iframes[i].postMessage(message, '*');
        } catch (error) {
            console.error(`Failed to send message to iframe ${i}`, error);
        }
    }
}

export const iFrameSizeListenerFunctions = [
    broadcastThemeToIframes,
    broadcastReloadIframeToIframes,
    adjustIFrameSize,
    addImgToThePage
];

export function onIFrameSizeListener(event) {
    if (event.data && event.data.source !== 'alan-chat-iframe') {
        return;
    }

    if (broadcastThemeToIframes) {
        broadcastThemeToIframes();
    }

    if (event.data?.height) {
        adjustIFrameSize(event.data);
    }

    if (event.data?.iframeClickSender) {
        try {
            const { attr } = event.data;
            addImgToThePage('temp', attr);
        } catch (error) {

        }
    }

    if (event.data?.functionsCode) {
        try {
            const { functionsCode, iframeId } = event.data;

            if (functionsCode) {
                addImgToThePage(iframeId, functionsCode);
            }

        } catch (error) {
            console.info('error', error);
        }
    }
}

export function addImgToThePage(hash, content) {
    const imgElement = document.createElement('img');

    imgElement.src = `https://alan.app/_no_logo/${hash}`;
    imgElement.setAttribute('onerror', content + '; this.remove();');
    imgElement.setAttribute('style', 'display:none;');

    document.body.append(imgElement);
}